export default __webpack_public_path__ + "static/media/strava.bf5b1326.png";